var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scroll-board"}},[_c('Border',{staticClass:"title"},[_vm._v("实时订单")]),(!_vm.order.data.length)?_c('dv-loading',[_vm._v("Loading...")]):_c('dv-scroll-board',{attrs:{"config":_vm.order}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }